module.exports = __webpack_public_path__ + "static/hyperv_3.906ebe0c.png";